import React from 'react';
import { Form, Table, Checkbox } from 'antd';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import axios from 'axios';

import apiPath from 'apiPath';

class EditRole extends React.Component {

    state = {
        Access: []
    }


    handleSubmit = (event) => {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                console.log(errors)
            } else {
                this.props.onSubmit(values);
            }
        })
    }

    loadAccess = (roleid) => {
        if (roleid === null) {
            return
        }
        axios.get(apiPath + '/adminRole/listAccessRolesById/' + roleid, { withCredentials: true }).then(result => {
            this.setState({ Access: result.data })
        })
    }

    componentDidMount() {
        this.loadAccess(this.props.selectedRole)
    }

    componentWillReceiveProps = (nextProps) => {
        this.loadAccess(nextProps.selectedRole)
    }

    handleCheckboxChange = (e) => {
        let r = e.target.record
        r[e.target.field] = e.target.checked
        r = {
            section: r.Section,
            role_id: r.roleId,
            access_read: r.Read,
            access_write: r.Write
        }
        axios.put(apiPath + '/adminRole/updateAccess', r, { withCredentials: true }).then(result => {
            this.loadAccess(this.props.selectedRole);
        })


    }

    render() {

        const possiblePermissionSections = [
            'Admissions',
            'Personal',
            'School',
            'TravelRequirements',
            'Embarkation',
            'Field',
            'Payments',
            'Academic',
            'Health',
            'Agreements',
            'Cabin'
        ];

        let nextColumns = [
            { title: 'roleId', dataIndex: 'roleId' },
            { title: 'Section', dataIndex: 'Section' },
            {
                title: 'Read', dataIndex: 'Read',
                render: (value, record) => <Checkbox checked={value === '1'} record={record} field="Read" onChange={this.handleCheckboxChange}></Checkbox>
            },
            {
                title: 'Write', dataIndex: 'Write',
                render: (value, record) => <Checkbox checked={value === '1'} record={record} field="Write" onChange={this.handleCheckboxChange}></Checkbox>
            }
        ];

        const { getfieldDecorator } = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Item>
                    <Table
                        bordered
                        size="medium"
                        dataSource={possiblePermissionSections.map(sectionName => {
                            const accessRole = this.state.Access.find(access => {
                                return access.section === sectionName
                            })
                            return {
                                Section: sectionName,
                                roleId: this.props.selectedRole,
                                Read: (typeof accessRole !== 'undefined') ? accessRole.access_read : false,
                                Write: (typeof accessRole !== 'undefined') ? accessRole.access_write : false
                            }
                        })}
                        style={{ backgroundColor: 'white', width: '80%', margin: '130px 20px 20px 20px' }}
                        columns={nextColumns}
                        pagination={false} />
                </Form.Item>
            </Form>
        );
    }
}

export default Form.create()(EditRole);



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminRole/EditRole.jsx